import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import * as React from 'react';
import { mergeStyles } from '@cian/utils';
import * as styles from './DefaultArrows.css';
import { Arrow } from './parts/Arrow';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var DefaultArrows = function DefaultArrows(props) {
  var leftAreaWidth = props.leftAreaWidth,
    rightAreaWidth = props.rightAreaWidth,
    showLeft = props.showLeft,
    showRight = props.showRight,
    defaultArrowStyles = props.styles,
    size = props.size,
    clickHandler = props.clickHandler;
  return /*#__PURE__*/_jsx("div", {
    className: styles['default-arrows-container'],
    "data-testid": "DefaultArrows",
    children: /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({}, mergeStyles(styles['default-arrows-wrapper'], defaultArrowStyles)), {}, {
      children: [/*#__PURE__*/_jsx(Arrow, {
        direction: -1,
        width: leftAreaWidth,
        clickHandler: clickHandler,
        show: showLeft,
        size: size
      }), /*#__PURE__*/_jsx(Arrow, {
        direction: 1,
        width: rightAreaWidth,
        clickHandler: clickHandler,
        show: showRight,
        size: size
      })]
    }))
  });
};